module.exports = __webpack_public_path__ + "static/media/1POLICY35.977e0b59.jpg";